/**Graph theme colors */
export const SurepayrollGraphThemeColors: string[] = ['#01D788', '#FE5A58', '#FFCF50', '#5D62F6'];

export const RunpayrollGraphThemeColors: string[] = ['#88ac2e', '#ffd262', '#fb9108', '#1d90e0'];

export const PaychexGraphThemeColors: string[] = ['#88ac2e', '#ffd262', '#fb9108', '#0059a2'];

export const SuntrustGraphThemeColors: string[] = ['#88ac2e', '#ffd262', '#fb9108', '#1d90e0'];

export const TruistGraphThemeColors: string[] = ['#afe0e2', '#7c6992', '#afabc9', '#2e1a47'];

/**Bar theme colors */
export const SurepayrollBarThemeColors: string[] = ['#FE5A58', '#5D62F6', '#FFCF50', '#01D788'];

export const RunpayrollBarThemeColors: string[] = ['#ffd262', '#1d90e0', '#fb9108', '#88ac2e'];

export const PaychexBarThemeColors: string[] = ['#ffd262', '#0059a2', '#fb9108', '#88ac2e'];

export const SuntrustBarThemeColors: string[] = ['#ffd262', '#1d90e0', '#fb9108', '#88ac2e'];

export const TruistBarThemeColors: string[] = ['#7c6992', '#2e1a47', '#afabc9', '#afe0e2'];

/**Summary theme colors */
/**1st-Take home pay 2nd-Pre-Tax 3rd-Taxes 4th-Post Tax Deductions */
export const SurepayrollSummaryThemeColors: string[] = ['#01D788', '#FFCF50', '#5D62F6', '#FE5A58'];

export const RunpayrollSummaryThemeColors: string[] = ['#88ac2e', '#fb9108', '#1d90e0', '#ffd262'];

export const PaychexSummaryThemeColors: string[] = ['#88ac2e', '#fb9108', '#0059a2', '#ffd262'];

export const SuntrustSummaryThemeColors: string[] = ['#88ac2e', '#fb9108', '#1d90e0', '#ffd262'];

export const TruistSummaryThemeColors: string[] = ['#afe0e2', '#afabc9', '#2e1a47', '#7c6992'];
